import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import * as types from '@orgmap/store/types';
import * as userTypes from '@account/store/types';

import { PublicAddressMemberListContainer } from '@orgmap/containers'

@Component({
   name: 'PublicMembersView',
   components: { PublicAddressMemberListContainer },
   computed: {
        ...mapGetters({
      }),
    },
   methods: {
        ...mapActions({
        }),
        ...mapMutations({
        }),
    },
})
export default class PublicMembersView extends Vue {

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //  

    @Prop({ type: Object, default: null }) dept!: orgmap.TDepartmentTreeItem;

}